<div *ngIf="isMegaMenuReady">
  <div class="heading">
    <span>Business Groups</span>
    <span
      class="info-circle"
      nz-tooltip
      nzTooltipTitle="Some sub-groups contain companies from other industries"
      nzTooltipPlacement="top"
    >
      <va-icon size="small" name="info-circle" class="info-icon"></va-icon>
    </span>
  </div>

  <nz-radio-group
    [(ngModel)]="selectedCluster"
    (ngModelChange)="onClusterChange($event)"
    class="sub-group"
  >
    <label
      *ngFor="let item of clusters"
      nz-radio
      [title]="item.name"
      [nzValue]="item.id"
      class="sub-group-items"
    >
      <div class="sub-group-text">
        <span>{{ item.name | textEllipsis: 30 }}</span>
        <span>{{ item.count }}</span>
      </div>
    </label>
  </nz-radio-group>
</div>

<app-custom-skeleton
  *ngIf="!isMegaMenuReady"
  [customSkeletonConfig]="skeletonDefaultConfig"
  ngClass="industry-skeleton-title"
></app-custom-skeleton>
